import {FlowAllocationType, flowAllocationTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<FlowAllocationType>;

export const FlowAllocationTypeSelect = (props: Props) => {
    const {options = flowAllocationTypes, ...rest} = props;
    return <BaseDbCodeSelect options={options} {...rest} />;
};
